import Input from '@vromo/ui/components/Input';
import { action } from 'mobx';
import { observer } from 'mobx-react-lite';
import React, { ChangeEvent } from 'react';
import styles from '../widgetEditor.style';
import { Widget } from '@vromo/models';
import { WidgetInputItem } from '../widgetUtils';

interface Props {
    widget: Widget;
    item: WidgetInputItem;
}

const InputSection = observer(({ widget, item }: Props) => (
    <>
        <label>{item.title}</label>
        <Input
            maxLength={item?.charLimit}
            placeholder={item?.placeholder || item.title}
            value={widget.metadata[item.value]}
            onChange={action(
                (e: ChangeEvent<HTMLInputElement>) =>
                    (widget.metadata[item.value] = e.target.value)
            )}
            style={styles.input}
        />
    </>
));

export default InputSection;